var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0H25C25 0 25.5 0 25.5 0.75C25.5 1.5 25 1.5 25 1.5H1C0.5 1.5 0.5 0.756996 0.5 0.756996C0.5 0.756996 0.5 0 1 0Z",
    fill: "#1B75BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.44 5.92967L13.9532 2.74083L13.9474 2.73546C13.8437 2.64068 13.717 2.57119 13.5745 2.53811C13.2906 2.47113 12.9789 2.55394 12.7645 2.78831L9.57038 6.28098C9.26152 6.61872 9.28545 7.15493 9.62319 7.4638C9.96092 7.77267 10.4971 7.74873 10.806 7.41099L12.6366 5.40928L12.6897 10.3026C12.7101 10.76 13.0412 11.022 13.4986 11.0016C13.9559 10.9812 14.3083 10.724 14.3083 10.3026L14.3083 5.33468L16.31 7.16529C16.6478 7.47416 17.184 7.45022 17.4928 7.11249C17.8017 6.77475 17.7778 6.23854 17.44 5.92967Z",
    fill: "#1B75BC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61433 17.9259L12.9441 21.2784L12.9496 21.2841C13.0486 21.3837 13.1719 21.4592 13.3126 21.4991C13.5929 21.5796 13.9083 21.5119 14.1336 21.2881L17.4918 17.9528C17.8165 17.6303 17.8183 17.0935 17.4958 16.7688C17.1733 16.4441 16.6366 16.4422 16.3118 16.7647L14.3872 18.6763L14.3872 13.2198C14.3888 12.7619 14.2182 12.5027 13.5004 12.5002C13.0321 12.4986 12.7155 12.7622 12.7139 13.22L12.7139 18.6705L10.8024 16.7459C10.4798 16.4212 9.9431 16.4194 9.61837 16.7419C9.29364 17.0644 9.29181 17.6011 9.61433 17.9259Z",
    fill: "#1B75BC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 23H25C25 23 25.5 23 25.5 23.75C25.5 24.5 25 24.5 25 24.5H1C0.5 24.5 0.5 23.757 0.5 23.757C0.5 23.757 0.5 23 1 23Z",
    fill: "#1B75BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandAll);
export default __webpack_public_path__ + "static/media/ExpandAll.c02081f5e070dce75c2c0d8cc7ffa634.svg";
export { ForwardRef as ReactComponent };